import { createUniqueFieldSchema } from '@ts-react/form'
import { z } from 'zod'

export const ContactGuidSchema = createUniqueFieldSchema(
  z.string().nonempty('You must select a contact'),
  'contactGuid',
)
